import { Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "../AppLayout";
import HomePage from "./home/HomePage";
import LobbyPage from "./lobby/LobbyPage";
import SpacePage from "./space/SpacePage";
import { SpaceEntryRedirect } from "./space/SpaceEntryRedirect";
import CheckoutPage from "./order/CheckoutPage";
import LegalDocPage from "./legal/LegalDocPage";

/** 龙粉社平台站路由（输入空间号进入） */
function PlatformApp() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/follows" element={<Navigate to="/" replace />} />
        <Route path="/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/orders" element={<Navigate to="/" replace />} />
        <Route path="/lobby/:spaceId" element={<LobbyPage />} />
        <Route path="/space/:spaceId" element={<SpaceEntryRedirect />} />
        <Route path="/space/:spaceId/:section" element={<SpacePage />} />
        <Route path="/checkout/:spaceId/:orderId" element={<CheckoutPage />} />
        <Route path="/legal/:slug" element={<LegalDocPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default PlatformApp;
